const managersCollectionFiltersTemplate = {
  name: "",
  countries: [],
  states: [],
  cities: [],
  titles: [],
  skills: [],
  projects: [],
};

export default managersCollectionFiltersTemplate;